"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalInfoSchema = exports.SearchSuggestionItemSchema = exports.AutoCompleteResponseSchema = exports.AutoCompleteItemSchema = exports.AutoCompleteRequestSchema = exports.SearchHomeConfigResponseSchema = exports.SearchHomeResponseSchema = exports.SearchHomeRequestSchema = exports.InterestSearchResponseSchema = exports.InterestSearchDeleteRequestSchema = exports.InterestSearchRequestSchema = exports.InterestSearchItemSchema = exports.GlobalAccommodationSchema = exports.LocalAccommodationSchema = exports.VerticalSubSchema = exports.VerticalSchema = void 0;
var zod_1 = require("zod");
/*
 * 버티컬 카테고리
 */
exports.VerticalSchema = zod_1.z.enum([
    'LOCAL_ACCOMMODATION',
    'GLOBAL_ACCOMMODATION',
    'LOCAL_LEISURE',
    'LOCAL_ENTERTAINMENT',
]);
exports.VerticalSubSchema = zod_1.z.enum(['MOTEL', 'HOTEL', 'PENSION', 'GUESTHOUSE']);
/*
 * 국내숙소
 */
exports.LocalAccommodationSchema = zod_1.z.object({
    checkInDate: zod_1.z.string().nullish(),
    checkOutDate: zod_1.z.string().nullish(),
    capacityAdults: zod_1.z.number().nullish(),
    childrenAges: zod_1.z.array(zod_1.z.number()).nullish(),
});
/*
 * 해외숙소
 */
exports.GlobalAccommodationSchema = zod_1.z.object({
    checkInDate: zod_1.z.string().nullish(),
    checkOutDate: zod_1.z.string().nullish(),
    rooms: zod_1.z
        .array(zod_1.z.object({
        capacityAdults: zod_1.z.number().nullish(),
        childrenAges: zod_1.z.array(zod_1.z.number()).nullish(),
    }))
        .nullish(),
});
/*
 * 최근 검색어
 */
exports.InterestSearchItemSchema = zod_1.z.object({
    type: zod_1.z.literal('SEARCH_HISTORY'),
    keyword: zod_1.z.string(),
    subtitle: zod_1.z.string().nullish(),
    icon: zod_1.z.string().nullish(),
    action: zod_1.z.object({
        web: zod_1.z.string(),
        app: zod_1.z.string(),
    }),
    localAccommodation: exports.LocalAccommodationSchema.nullish(),
    globalAccommodation: exports.GlobalAccommodationSchema.nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional().nullish(),
});
exports.InterestSearchRequestSchema = zod_1.z.object({
    verticalCategory: exports.VerticalSchema.nullish(),
    verticalSubCategory: exports.VerticalSubSchema.nullish(),
    keyword: zod_1.z.string().nullish(),
    localAccommodation: exports.LocalAccommodationSchema.nullish(),
    globalAccommodation: exports.GlobalAccommodationSchema.nullish(),
});
exports.InterestSearchDeleteRequestSchema = zod_1.z.object({
    keyword: zod_1.z.string().nullish(),
    isDeleteAll: zod_1.z.boolean().nullish(),
    verticalCategory: exports.VerticalSchema.nullish(),
    verticalSubCategory: exports.VerticalSubSchema.nullish(),
});
exports.InterestSearchResponseSchema = zod_1.z.object({
    verticalInfo: zod_1.z
        .object({
        verticalCategory: exports.VerticalSchema,
        verticalSubCategory: exports.VerticalSubSchema.nullish(),
        verticalTitle: zod_1.z.string(),
    })
        .optional()
        .nullish(),
    placeholder: zod_1.z.string(),
    debouncingDelay: zod_1.z.number(),
    items: zod_1.z.array(exports.InterestSearchItemSchema).nullish(),
});
/*
 * 검색홈
 */
exports.SearchHomeRequestSchema = zod_1.z.object({
    verticalCategory: exports.VerticalSchema.nullish(),
    verticalSubCategory: exports.VerticalSubSchema.nullish(),
});
exports.SearchHomeResponseSchema = zod_1.z.object({
    verticalInfo: zod_1.z.object({
        verticalCategory: exports.VerticalSchema,
        verticalSubCategory: exports.VerticalSubSchema.nullish(),
        verticalTitle: zod_1.z.string(),
    }),
    placeholder: zod_1.z.string(),
    debouncingDelay: zod_1.z.number(),
    items: zod_1.z.array(exports.InterestSearchItemSchema).nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.any()).nullish(),
});
exports.SearchHomeConfigResponseSchema = zod_1.z.object({
    placeholder: zod_1.z.string(),
    debouncingDelay: zod_1.z.number(),
    items: zod_1.z.array(zod_1.z.object({
        verticalInfo: zod_1.z.object({
            verticalCategory: exports.VerticalSchema,
            verticalSubCategory: exports.VerticalSubSchema.nullish(),
            verticalTitle: zod_1.z.string(),
        }),
        placeholder: zod_1.z.string(),
    })),
});
/*
 * 자동완성
 */
exports.AutoCompleteRequestSchema = zod_1.z.object({
    verticalCategory: exports.VerticalSchema.nullish(),
    verticalSubCategory: exports.VerticalSubSchema.nullish(),
    keyword: zod_1.z.string(),
    withoutAutocomplete: zod_1.z.boolean().nullish(),
    localAccommodation: exports.LocalAccommodationSchema.nullish(),
    globalAccommodation: exports.GlobalAccommodationSchema.nullish(),
});
exports.AutoCompleteItemSchema = zod_1.z.object({
    type: zod_1.z.literal('SEARCH_AUTOCOMPLETE'),
    groupType: zod_1.z.enum(['CID', 'USER_QUERY', 'ONSITE_MARKETING', 'PRODUCT', 'ARTIST']).optional().nullish(),
    title: zod_1.z.string(),
    subtitle: zod_1.z.string().nullish(),
    image: zod_1.z.string().nullish(),
    action: zod_1.z.object({
        web: zod_1.z.string(),
        app: zod_1.z.string(),
    }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional().nullish(),
});
exports.AutoCompleteResponseSchema = zod_1.z.object({
    action: zod_1.z.object({
        web: zod_1.z.string(),
        app: zod_1.z.string(),
    }),
    items: zod_1.z
        .array(zod_1.z.object({
        type: zod_1.z.enum(['CID', 'USER_QUERY', 'ONSITE_MARKETING', 'PRODUCT', 'ARTIST']),
        items: zod_1.z.array(exports.AutoCompleteItemSchema),
    }))
        .optional(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional().nullish(),
});
exports.SearchSuggestionItemSchema = zod_1.z.union([exports.InterestSearchItemSchema, exports.AutoCompleteItemSchema]);
/*
 * 카테고리
 */
exports.VerticalInfoSchema = zod_1.z.object({
    verticalCategory: exports.VerticalSchema.nullish(),
    verticalSubCategory: exports.VerticalSubSchema.nullish(),
    verticalTitle: zod_1.z.string(),
});
